export default {"src":"/_next/static/media/ost.b4ec1a24.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};